var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7026 21.779L34.4755 11.5518C34.1082 11.1229 33.4625 11.0728 33.0336 11.4403C32.6046 11.8077 32.5546 12.4533 32.922 12.8823C32.9563 12.9223 32.9936 12.9596 33.0336 12.9938L41.5118 21.4823H1.02268C0.457902 21.4823 0 21.9402 0 22.5051C0 23.07 0.457902 23.5278 1.02268 23.5278H41.5118L33.0336 32.006C32.6046 32.3734 32.5546 33.019 32.922 33.448C33.2895 33.877 33.935 33.927 34.364 33.5595C34.404 33.5253 34.4414 33.488 34.4755 33.448L44.7027 23.2209C45.0991 22.8221 45.0991 22.1779 44.7026 21.779Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightarrow);
export default __webpack_public_path__ + "static/media/rightarrow.85aaa73163d5b5040dcbfe5416e1ffdb.svg";
export { ForwardRef as ReactComponent };